import React from "react";
import { motion } from "framer-motion";

export default function VesselToggle({ vessels, active, onChange }) {
  return (
    <div
      className="hidden lg:flex items-center gap-1 p-1 border border-[#D8AB4E]/20 bg-[#0A0A0A]/80"
      data-testid="vessel-toggle"
    >
      {vessels.map((v) => {
        const isActive = active === v.id;
        return (
          <button
            key={v.id}
            data-testid={`vessel-${v.id}`}
            onClick={() => onChange(v.id)}
            className="relative px-4 py-2 text-[10px] font-mono-data tracking-[0.18em] uppercase transition-colors"
            style={{ color: isActive ? "#040404" : "#a1a1aa" }}
          >
            {isActive && (
              <motion.span
                layoutId="vessel-pill"
                className="absolute inset-0"
                style={{ background: v.color }}
                transition={{ type: "spring", stiffness: 350, damping: 32 }}
              />
            )}
            <span className="relative z-10 flex items-center gap-2">
              <span
                className="h-1.5 w-1.5 rounded-full"
                style={{ background: isActive ? "#040404" : v.color }}
              />
              {v.name}
            </span>
          </button>
        );
      })}
    </div>
  );
}
